/* Defines URIs for types of errors specific to all services.
See the Problem Details spec https://tools.ietf.org/html/rfc7807#section-3.1  */
export enum ErrorTypes {
  SdCard_BadUploadRequest = 'urn:lmt:sd:BadUploadRequest',
  SdCard_MissingTherapyStatistics = 'urn:lmt:sd:MissingTherapyStatistics',
  SdCard_AllStatisticsBeforeLimit = 'urn:lmt:sd:AllStatisticsBeforeLimit',
  SdCard_AllStatisticsAfterLimit = 'urn:lmt:sd:AllStatisticsAfterLimit',
  SdCard_InvalidP2_8FirmwareVersion = 'urn:lmt:sd:InvalidP2_8FirmwareVersion',
  SdCard_InvalidP2_8FileExtension = 'urn:lmt:sd:InvalidP2_8FileExtension',
  SdCard_InvalidP3FirmwareVersion = 'urn:lmt:sd:InvalidP3FirmwareVersion',
  SdCard_InvalidP3FileExtension = 'urn:lmt:sd:InvalidP3FileExtension',
  SdCard_DeviceDoesNotBelongToOrganisation = 'urn:lmt:sd:DeviceDoesNotBelongToOrganisation',
  SdCard_InactivePic = 'urn:lmt:sd:InactivePic',
  StatisticsGateway_PdfPeriodTooLong = 'urn:lmt:stats-gateway:PdfPeriodTooLong',
  StatisticsGateway_CsvPeriodTooLong = 'urn:lmt:stats-gateway:CsvPeriodTooLong',
  StatisticsGateway_NotSupportedDeviceGeneration = 'urn:lmt:stats-gateway:NotSupportedDeviceGeneration',
  TooManyRequests = 'urn:lmt:too-many-requests',
  AccessDenied = 'urn:lmt:access-denied',
  DeleteOrganisationForbidden = 'urn:lmt:core:DeleteForbiddenOrganisation',
  FileIsEmpty = 'urn:lmt:core:FileIsEmpty',
  TooManyDevicesInFile = 'urn:lmt:core:TooManyDevicesInFile',
}
